import React, { useState } from "react";
import { Link } from "react-router-dom";
import Scrollbar from 'react-scrollbars-custom';
import "./Tiles.styles.scss";
import { BYO_INSTANT_CHART_ID_QUERY_PARAM_NAME, BYO_WORDS_COUNT_QUERY_PARAM_NAME } from "@constants/general";

const Tile = ({
    isLink,
    handleClick,
    name,
    id,
    wordsCount,
    testId,
}) => {
    const [x, setX] = useState(0);
    const [y, setY] = useState(0);
    let Component = 'div';
    const props = {
        'data-testid': testId,
    };
    if (isLink) {
        Component = Link;
        props.to = `/byo?${BYO_INSTANT_CHART_ID_QUERY_PARAM_NAME}=${id}&${BYO_WORDS_COUNT_QUERY_PARAM_NAME}=${wordsCount}`;
    } else {
        props.onClick= handleClick;
    }

    return (
        <Component
            onMouseEnter={(event) => {
                setX(event.clientX - event.currentTarget.getBoundingClientRect().left);
                setY(event.clientY - event.currentTarget.getBoundingClientRect().top);
            }}
            onMouseLeave={(event) => {
                setX(event.clientX - event.currentTarget.getBoundingClientRect().left);
                setY(event.clientY - event.currentTarget.getBoundingClientRect().top);
            }}
            className="tile"
            {...props}
        >
            <div
                className="tile__fill"
                style={{
                    top: y,
                    left: x,
                }}
            />
            <div
                className="tile__text"
                data-testid={`textGridTileTitle`}
            >
                {name}
            </div>
        </Component>
    )
};

const Tiles = (
    {
        data = [],
        zoomIndex,
        zoomLevel,
        handleItemClick,
        isItemLink,
    }
) => {

    const tilesClassList = new Set([
        'tiles',
        zoomLevel > 0 ? `tiles--zoomed-${zoomLevel}` : '',
        zoomLevel === 0 ? 'tiles--zoomed-out' : ''
    ]);

    return (
        <div className={Array.from(tilesClassList).join(' ')}>
            <Scrollbar>
                <div className="tiles__inner">
                    {data.map((item, index) => (
                        <Tile
                            key={index}
                            isLink={isItemLink}
                            {...item}
                            handleClick={() => handleItemClick(index)}
                            testId={`buttonInstantChartsGridTile-${zoomIndex}-${index}`}
                        />
                    ))}
                </div>
            </Scrollbar>
        </div>
    )
};

export default Tiles;